import composeValidators from './compose-validators';
import inRange from './in-range';
import min from './min';
import formatPrice from '../formatters/price';
export default (({
  defaultMinLoanAmount,
  defaultMaxLoanAmount
}) => stateRef => value => {
  let state;
  if (typeof stateRef === 'function') {
    state = stateRef();
  } else {
    state = stateRef || {};
  }
  const minLoanAmount = state.minLoanAmount || defaultMinLoanAmount;
  const formattedMinLoan = formatPrice(minLoanAmount, {
    digits: 0
  });
  const formattedMaxLoan = formatPrice(defaultMaxLoanAmount, {
    digits: 0
  });

  // user might ask for $1,000 before filling in their home state, so we add a custom message explaining why they need
  // to update the loan amount to make it clear
  const customMinLoanValidation = minLoanAmount !== defaultMinLoanAmount ? min(minLoanAmount, {
    message: `Upgrade is only offering loans of at least ${formattedMinLoan} in your state.`
  }) : () => null;
  return composeValidators({
    error: [customMinLoanValidation, inRange(minLoanAmount, defaultMaxLoanAmount, {
      message: `Please enter loan amount between ${formattedMinLoan} and ${formattedMaxLoan}.`
    })]
  })({
    error: value
  }).error;
});